import AppErrorBoundary from "components/Common/AppErrorBoundary";
import { GROUP_LIST } from "codes";
import Loader from "components/Common/Loader";
import { roleRedirect } from "helpers/redirect";
import { Suspense, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useAppSelector } from "redux/hooks";

const IncomlendInternalLR = () => {
  const APP_PERMISSION = useAppSelector((state) => state.appState.permission);

  const location = useLocation();

  useEffect(() => {
    if (!GROUP_LIST.includes(APP_PERMISSION)) roleRedirect(APP_PERMISSION);
  }, [APP_PERMISSION, location.pathname]);

  return (
    <AppErrorBoundary scope="Incomlend internal routes">
      <Suspense fallback={<Loader />}>
        <Outlet />
      </Suspense>
    </AppErrorBoundary>
  );
};

export default IncomlendInternalLR;
